"use client";

import React from "react";
import { Loader } from "lucide-react";
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
export default function SupplierForm() {
  return <section data-section-id="58613" id="intresseanmälan-för-operatörer" className="bg-background py-20 md:py-24">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-bold text-primary font-serif tracking-tight">
            Intresseanmälan för operatörer
          </h2>
        </div>

        <div className="bg-white border border-border p-8 md:p-12 rounded-[3px] shadow-sm">
          <FormProvider formKey="operator_interest_form_become_operator" formId="operator_interest_form_become_operator" sectionName="supplier-form" className="mx-auto w-full" defaultValues={{
          name: "",
          email: "",
          phone: "",
          company: "",
          message: "",
          consent: false
        }} validationRules={{
          name: {
            required: true
          },
          email: {
            required: true,
            pattern: "email"
          },
          phone: {
            required: true,
            pattern: "phone"
          },
          company: {
            required: true
          },
          message: {
            required: true
          },
          consent: {
            required: true
          }
        }} submitText="Skicka Intresseanmälan" successMessage="Tack för din intresseanmälan! Vi återkommer till dig inom kort för att diskutera möjligheterna i din stad." errorMessage="Något gick fel vid inskickandet. Vänligen kontrollera fälten och försök igen.">
            <SupplierFormContent />
          </FormProvider>
        </div>
      </div>
    </section>;
}
function SupplierFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="rounded-[3px] bg-accent p-8 text-center border border-primary/20">
        <h3 className="mb-2 text-2xl font-bold text-primary font-serif">Tack!</h3>
        <p className="text-foreground font-sans">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 gap-x-8 gap-y-6 md:grid-cols-2">
        {}
        <FormField control={control} name="name" rules={{
        required: "Detta fält är obligatoriskt"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-sans font-medium">Ditt namn</FormLabel>
              <FormControl>
                <Input placeholder="Anna Svensson" {...field} className="bg-white text-foreground border-border rounded-[3px] placeholder:text-muted-foreground/50 focus-visible:ring-primary h-12" />
              </FormControl>
              <FormMessage className="text-destructive font-sans text-sm" />
            </FormItem>} />

        {}
        <FormField control={control} name="email" rules={{
        required: "E-postadress är obligatorisk",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Ogiltig e-postadress"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-sans font-medium">E-postadress</FormLabel>
              <FormControl>
                <Input type="email" placeholder="anna@example.com" {...field} className="bg-white text-foreground border-border rounded-[3px] placeholder:text-muted-foreground/50 focus-visible:ring-primary h-12" />
              </FormControl>
              <FormMessage className="text-destructive font-sans text-sm" />
            </FormItem>} />

        {}
        <FormField control={control} name="phone" rules={{
        required: "Telefonnummer är obligatoriskt"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-sans font-medium">Telefonnummer</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+46 70 123 45 67" {...field} className="bg-white text-foreground border-border rounded-[3px] placeholder:text-muted-foreground/50 focus-visible:ring-primary h-12" />
              </FormControl>
              <FormMessage className="text-destructive font-sans text-sm" />
            </FormItem>} />

        {}
        <FormField control={control} name="company" rules={{
        required: "Vänligen ange din stad"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-sans font-medium">Ort / Stad</FormLabel>
              <FormControl>
                <Input placeholder="t.ex. Stockholm eller Göteborg" {...field} className="bg-white text-foreground border-border rounded-[3px] placeholder:text-muted-foreground/50 focus-visible:ring-primary h-12" />
              </FormControl>
              <FormMessage className="text-destructive font-sans text-sm" />
            </FormItem>} />

        {}
        <div className="col-span-1 md:col-span-2">
          <FormField control={control} name="message" rules={{
          required: "Vänligen beskriv ditt intresse"
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="text-foreground font-sans font-medium">Berätta om dina planer</FormLabel>
                <FormControl>
                  <textarea placeholder="Beskriv ditt intresse för att driva en robotaxi-verksamhet i din stad..." {...field} className="flex min-h-[150px] w-full rounded-[3px] border border-border bg-white px-3 py-2 text-base text-foreground shadow-none placeholder:text-muted-foreground/50 focus-visible:outline-none focus-visible:ring-[1px] focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50 md:text-sm font-sans" />
                </FormControl>
                <FormMessage className="text-destructive font-sans text-sm" />
              </FormItem>} />
        </div>

        {}
        <div className="col-span-1 md:col-span-2">
          <FormField control={control} name="consent" rules={{
          required: "Du måste godkänna behandlingen av dina uppgifter"
        }} render={({
          field: {
            value,
            onChange,
            ...field
          }
        }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0">
                <FormControl>
                  <input type="checkbox" checked={value} onChange={onChange} {...field} className="mt-1 h-4 w-4 shrink-0 rounded-[3px] border border-border bg-white text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" />
                </FormControl>
                <div className="space-y-1 leading-none">
                  <FormLabel className="text-base font-normal text-foreground font-sans">
                    Jag samtycker till att mina uppgifter lagras enligt GDPR.{" "}
                    <Link to="#" className="text-primary hover:underline font-medium">
                      Läs vår integritetspolicy här.
                    </Link>
                  </FormLabel>
                  <FormMessage className="text-destructive font-sans text-sm" />
                </div>
              </FormItem>} />
        </div>

        {}
        <div className="col-span-1 mt-4 md:col-span-2">
          <Button type="submit" disabled={isSubmitting} className="w-full rounded-[3px] bg-primary px-8 py-7 text-lg font-bold text-primary-foreground hover:bg-primary/90 transition-colors uppercase tracking-wider">
            {isSubmitting ? <>
                <Loader className="mr-2 h-5 w-5 animate-spin" />
                Skickar...
              </> : "SKICKA INTRESSEANMÄLAN"}
          </Button>
        </div>
      </div>

      {submitError && <div className="mt-4 rounded-[3px] bg-red-50 p-4 text-destructive border border-red-100 font-sans text-sm">
          {submitError}
        </div>}
    </Form>;
}